import effectManager from '../module/effect';
import Scroll from '../module/molecules/scroll';
import movieManager from '../module/molecules/movie';
import topDeveloper from './topDeveloper';

let _effect = new effectManager();
let _scroll = new Scroll();
let _movie = new movieManager();
let _developerSlide = new topDeveloper();

export default class topManager {
    constructor() {
        this.scroll = $("#c-scroll");
        this.pager = $("#c-pager__trigger");
        this.header = $("#l-header");
        this.footer = $("#l-footer__social");
        this.canvas = $("#js__canvas");
        this.movie = $("#l-movie");
        this.i = 0;
        this.j = 0;
    }
    init(_status,type,_root,_path){

        let _this = this;

        if(type !== 'landing'){
            if(('sessionStorage' in window) && (window.sessionStorage !== null)) {
                _status.nextcurrent = Number(sessionStorage.access_count);
            }
            $('#vue-switch-scene').find('.p-switch-scene__item').eq(11).click(); //再生
            _movie.bgSet(_status,_root,_path);
            _movie.set(_status);
            _scroll.normal(_status);
            $("#l-root").css({'display':'block'});
            TweenLite.set(_this.canvas, { 'display': 'block' });
            _status.loading = true;
            _this.scroll.addClass('is-done is-show');
        }else{
            _status.nextcurrent = 0;
            //set
            let h = $('.headerglobalnavi').height();
            TweenLite.set(this.header, {
                y:'-10px',
                opacity:0
            });
            if(Useragnt.mobile){
                TweenLite.set(this.pager, {
                    y:'-75px',
                    opacity:0
                });
                TweenLite.set(this.footer.children(), {
                    x:'-70px',
                    y:'70px',
                    opacity:0
                });
            }else{
                TweenLite.set(this.pager, {
                    x:'-75px',
                    opacity:0
                });
                TweenLite.set(this.footer.children(), {
                    x:'70px',
                    y:'-70px',
                    opacity:0
                });
            }
            TweenLite.set(this.movie, {
                display: 'none',
                opacity:0
            });
            TweenLite.set(this.canvas, {
                opacity:0
            });

            _status.loaded = true;
            _this.motion(_status,_this);

        }

    }
    motion(_status,_this){

        TweenLite.set(_this.canvas, { 'display': 'block' });

        //motion
        TweenMax.to(_this.movie, 1.08, {
            delay:0.3,
            autoAlpha: 1,
            display: 'block',
            easing: Circ.easeOut,
            onStart:function(){
                setTimeout(function () {
                    $("#l-root").css({'display':'block'});
                }, 550);
            }
        });

    }

    movieEnd(_status,_root,_path){

        let _this = this;

        // $.getScript("http://192.168.0.15/~macbookpro13/denso-maas/public/content/dam/denso/common/language-variation/ja/innovation/technology/maas/js/main.min.js", function(){
        //     TweenMax.to(_this.movie, .98, {
        //         autoAlpha: 0,
        //         display: 'none',
        //         scale:.98,
        //         easing: Circ.easeOut
        //     });
        //     if (_status.nextcurrent === 0) {
        //         _this.webglmotion(_status,_this,_root,_path,_movie);
        //     }
        // });
        TweenMax.to(_this.movie, .98, {
            autoAlpha: 0,
            display: 'none',
            scale:.98,
            easing: Circ.easeOut
        });
        if (_status.nextcurrent === 0) {
            _this.webglmotion(_status,_root,_path);
        }

    }

    webglmotion(_status,_root,_path){

        let _this = this;

        $('body .pace').remove();
        $('#vue-switch-scene').find('.p-switch-scene__item').eq(11).click(); //再生

        _scroll.normal(_status);
        _this.scroll.addClass('is-done is-show');
        _this.canvas.css({"z-index":0});
        TweenMax.to(_this.canvas, .38, {
            delay:.62,
            'opacity': 1,
            ease: Power4.easeOut
        });
        setTimeout(function () {
            if(!Useragnt.mobile){
                TweenMax.to(_this.pager, .38, {
                    delay:.8,
                    opacity:1,
                    x:0,
                    ease: Power4.easeOut
                });
            }
            _status.loading = true;
        },1500);
        _movie.bgSet(_status,_root,_path);
        setTimeout(function () {
            _movie.set(_status);
        },3500);

    }
}